module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/paypal-icon-logo-b22eae12c9e660152898de1df3e6aa5c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/paypal-icon-logo.svg
// module id = 5ZbG
// module chunks = 24